import config from '../config'
import http from '../http'

export default {

getFbsRules:  async function(payload) {
	const res = await http({
		url: config.GET_RULES_BY_COUNTRY,
		method: 'post',
		data: {
			...payload
		}
	})
	return res.data
},

deleteRule:  async function(payload) {
	const res = await http({
		url: config.DELETE_RULES,
		method: 'post',
		data: {
			...payload
		}
	})
	return res.data
},

addFbsRules:  async function(payload) {
	const res = await http({
		url: config.CREATE_FBS_RULES,
		method: 'post',
		data: {
			...payload
		}
	})
	return res.data
},
	

 sellerUpdatePurchase:async function(payload) {
	const res = await http({
		url: config.SELLER_UPDATA_PURCHASEORDER,
		method: 'post',
		data: payload
	})
	return res.data
},
 //打印baraCode
 printBarCode:  async function(payload) {
	const res = await http({
		url: config.PRINT_PRODUCT_BAR_CODE,
		method: 'post',
		data: payload
	})
	return res.data
},
 //获取卖家采购数据
 getPurchaseOrder:  async function(payload) {
 	const res = await http({
 		url: config.GET_PURCHASE_ORDER,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 //删除入库单
 removePurchaseOrder:  async function(payload) {
 	const res = await http({
 		url: config.REMOVE_PURCHASE_ORDER,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },

 payFbsOrder:  async function(payload) {
	const res = await http({
		url: config.PAY_FBS_ORDER,
		method: 'post',
		data: {
			...payload
		}
	})
	return res.data
},
}
